import React from 'react'
import { Text, Box, Flex, getPaletteColor } from 'pcln-design-system'
import styled, { css } from 'styled-components'
import { noop } from 'lodash'

const Wrapper = styled(Box)`
  ${({ isSelected }) =>
    !isSelected &&
    css`
      cursor: pointer;
    `}

  border: 1px solid
    ${({ isSelected }) => getPaletteColor(isSelected ? 'primary.base' : 'background.lightest')};

  ${(props) => props.theme.mediaQueries.xl} {
    ${({ isSelected }) =>
      !isSelected &&
      css`
        &:hover {
          border: 1px solid ${getPaletteColor('primary.base')};
          background-color: ${getPaletteColor('primary.light')};
        }
      `}
  }
`
export interface IFlexDateCard {
  className?: string
  date: string
  priceText: string
  priceHighlightColor?: string
  stopsText: string
  isSelected?: boolean
  onClick?: () => void
  description?: string
  descriptionColor?: string
}

/** @public */
/* eslint-disable react/jsx-no-bind */
const FlexDatesCard: React.FC<IFlexDateCard> = ({
  date,
  priceText,
  priceHighlightColor,
  stopsText,
  isSelected,
  onClick,
  description,
  descriptionColor,
  ...props
}: IFlexDateCard) => {
  return (
    <Wrapper
      px={2}
      py={1}
      borderRadius='xl'
      color={isSelected ? 'primary.base' : 'background.lightest'}
      boxShadowSize='sm'
      isSelected={isSelected}
      onClick={!isSelected && onClick}
      {...props}
    >
      <Flex justifyContent='space-between'>
        <Text bold fontSize={[0, 0]}>
          {date}
        </Text>
        <Box bg={!isSelected && priceHighlightColor} px={1} borderRadius='full'>
          <Text fontSize={1}>{priceText}</Text>
        </Box>
      </Flex>
      <Flex alignItems='center' mt={1}>
        <Text color={isSelected ? 'text.lightest' : 'text.light'} fontSize={0}>
          {stopsText}
        </Text>
        {description ? (
          <Text ml='auto' fontSize={0} fontWeight='bold' color={descriptionColor}>
            {description}
          </Text>
        ) : null}
      </Flex>
    </Wrapper>
  )
}

FlexDatesCard.defaultProps = {
  onClick: noop,
  descriptionColor: 'success.base',
}

export default FlexDatesCard
